function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 10H82C84.2091 10 86 11.7909 86 14V58H26V10Z",
  fill: "#D8DDEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 14C11 11.7909 12.7909 10 15 10H62C64.2091 10 66 11.7909 66 14V58H11V14Z",
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 54,
  width: 100,
  height: 4,
  rx: 2,
  fill: "#F5F8FA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 25,
  width: 24,
  height: 14,
  rx: 4,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 28,
  width: 4,
  height: 8,
  rx: 2,
  fill: "#D8DDEB"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 82.5,
  cy: 10.5,
  r: 7.5,
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M82.5 3.50001C78.634 3.50001 75.5 6.63402 75.5 10.5C75.5 14.3659 78.634 17.5 82.5 17.5C86.3659 17.5 89.5 14.3659 89.5 10.5C89.5 6.63402 86.3659 3.50001 82.5 3.50001ZM72 10.5C72 4.70101 76.701 0 82.5 0C88.299 0 93 4.70101 93 10.5C93 12.7677 92.2811 14.8675 91.0588 16.5839L99.4875 25.0126C100.171 25.696 100.171 26.8041 99.4875 27.4875C98.8041 28.1708 97.696 28.1708 97.0126 27.4875L88.5839 19.0588C86.8675 20.2811 84.7677 21 82.5 21C76.701 21 72 16.299 72 10.5Z",
  fill: "url(#paint0_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 58,
  y1: 14,
  x2: 86,
  y2: 42,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgPackageWithMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 58,
    viewBox: "0 0 100 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = React.forwardRef(SvgPackageWithMagnifyingGlass);
export default __webpack_public_path__ + "static/media/package-with-magnifying-glass.defabd8c.svg";
export { ForwardRef as ReactComponent };